/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_List_TitleInputs */

const id_tld_pricing_list_title = /** @type {(inputs: Tld_Pricing_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar TLD`)
};

const en_tld_pricing_list_title = /** @type {(inputs: Tld_Pricing_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLDs`)
};

/**
* | output |
* | --- |
* | "TLDs" |
*
* @param {Tld_Pricing_List_TitleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_list_title = /** @type {((inputs?: Tld_Pricing_List_TitleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_List_TitleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_list_title(inputs)
	return id_tld_pricing_list_title(inputs)
});